import { Injectable } from "@angular/core";
import { IGenericSelectOption } from "../shared/types/forms";

@Injectable()
export class DatatableService {
	constructor() { }

	assertCellType(value: any, objProp?: string): any {
		if (typeof value === "number" || !isNaN(parseInt(value, 10))) {
			if (value % 1 === 0) {
				return typeof value === "string" ? parseInt(value, 10) : value;
			} else {
				return typeof value === "string" ? parseFloat(value) : value;
			}
		} else if (typeof value === "string" && isNaN(parseInt(value, 10))) {
			return value as string;
		} else if (typeof value === "object") {
			if ((value as IGenericSelectOption).hasOwnProperty("value")) {
				return (value as IGenericSelectOption).value;
			} else if (objProp && value.hasOwnProperty(objProp)) {
				return value.objProp as object;
			}
		} else {
			return value;
		}
	}
}
